import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import columns from "./columns";
import { WizTableForm } from "@/containers/common";

const { WizContainer, modelUtils } = framework_tool;
const { WizRow, WizCol, WizDataTable, WizButton, WizModal, WizTabs } = component_tool;

const exam = WizTableForm.Config.exam(this, {apiParams: { }})
const program = WizTableForm.Config.program(this, {apiParams: { isPower:false}})
const offlineProgram = WizTableForm.Config.offlineProgram(this, {apiParams: { }})
const survey = WizTableForm.Config.survey(this, {apiParams: { }})
const pathStage = WizTableForm.Config.pathStage(this, { apiParams: { state: 2 } })
const homeworkConfig = WizTableForm.Config.homework(this, { apiParams: { state: 1 } });
const applyConfig = WizTableForm.Config.apply(this, { apiParams: { state: 1 } });

const { getPageData } = utils_tool

class WizPreconditions extends WizContainer {
  componentName = "WizPreconditions";

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      records: [],
      selectedRows: [],
      activeKey: '0',
    };

    this.config = [
      { key: 0, title: '课程', ...program },
      { key: 1, title: '考试', ...exam },
      { key: 2, title: '问卷', ...survey },
      { key: 8, title: '线下课程', ...offlineProgram },
      { key: 12, title: '培训路径', ...pathStage },
      { key: 30, title: '作业', ...homeworkConfig },
      { key: 15, title: '报名', ...applyConfig },
    ]
  }

  getData = () => {
    const {bizType, bizId} = this.props

    this.doAction({
      path: "beforeCondition/list",
      payload: {
        key: "beforeCondition@list",
        apiParams: { bizType, bizId },
      },
    });
  }

  _componentDidMount() {
    this.getData()
  }

   // 监听属性和状态的变化
   propsAndStateOnChange = {
    list: this._list.bind(this),
    save: this._save.bind(this),
    // del: this._del.bind(this),
  };

  _list(nextProps, nextState) {
    const { list } = nextProps;
    if (list.success) {
      const data = list.data || {}
      const _records = this._formatData(data.conditionList, data.conditionGroupList)
      nextState.records = JSON.parse(JSON.stringify(_records))
      return true;
    }
    wizNotice.error(list.msg)
    return false;
  }

  _save(nextProps, nextState) {
    const { save } = nextProps;
    if (save.success) {
      wizNotice.success(save.msg)
      this.getData()
      return true;
    }
    wizNotice.error(save.msg)
    return false;
  }

  _formatData = (conditionList = [], conditionGroupList = []) => {
    return conditionList.map(val => ({
      ...val,
      isGroup: false,
      conditionActionType: 1,
    })).concat(conditionGroupList.map((val, index) => ({
      ...val,
      isGroup: true,
      conditionActionType: 1,
      children: val.children && val.children.length ? val.children.map(val => ({ ...val, pIndex: conditionList.length + index })) : undefined
    })))
  }

  formatRecords = (records) => {
    const _records = JSON.parse(JSON.stringify(records))
    const conditionList = _records.filter(val => !val.isGroup)
    const conditionGroupList = _records.filter(val => val.isGroup)
    const formatRecords = this._formatData(conditionList, conditionGroupList)

    return formatRecords
  }

  // 添加条件
  handleAddCondition = index => {
    this.setState({ visible: true, index, activeKey: '0' })
  }

  // 添加条件组
  handleAddConditionGroup = key => {
    const { records } = this.state
    const _records = JSON.parse(JSON.stringify(records))

    _records.push({
      isGroup: true,
      conditionType: 0,
      conditionBizId: new Date().getTime(),
      // conditionBizType: Number(key),
      rowId: new Date().getTime(),
    })

    this.setState({ records: this.formatRecords(_records) })
  }

  // 删除
  handleDelete = (index, pIndex) => {
    const { records } = this.state
    const _records = JSON.parse(JSON.stringify(records))

    if(pIndex !== undefined) {
      _records[pIndex].children.splice(index, 1)
    } else {
      _records.splice(index, 1)
    }

    this.setState({ records: this.formatRecords(_records) })
  }

  // 提交
  handleSubmit = () => {
    const { bizType, bizId } = this.props
    const { records } = this.state
    const conditionList = records.filter(val => !val.isGroup)
    const conditionGroupList = records.filter(val => val.isGroup)

    const _index = conditionGroupList.findIndex(val => val.children && !val.children.length)

    if(_index !== -1) {
      wizNotice.error(`第${conditionList.length + _index + 1}行组内条件不能为空`)
      return
    }

    this.doAction({
      path: "beforeCondition/save",
      payload: {
        key: "beforeCondition@save",
        apiParams: {
          bizType,
          bizId,
          conditionList,
          conditionGroupList
        }
      }
    })
  }

  // 重置
  handleReset = () => {
    const { list } = this.props;
    const data = list.data || {}
    const records = this._formatData(data.conditionList, data.conditionGroupList)
    this.setState({ records })
  }

  // 选择或和与
  handleSelectConditionType = (index, flag, pIndex) => {
    const { records } = this.state
    const _records = JSON.parse(JSON.stringify(records))

    if(pIndex !== undefined) {
      _records[pIndex].children[index].conditionType = flag
    } else {
      _records[index].conditionType = flag
    }
    this.setState({ records: _records })
  }

  // 格式化选择行的数据
  formatSelectedRows = (selectedRows, pIndex) => {
    const { activeKey } = this.state
    return selectedRows.map(val => ({
      isGroup: false,
      conditionType: 0,
      conditionBizType: Number(activeKey),
      conditionBizId: val.id,
      conditionBizName: val.name || val.title,
      trainPathName: val.trainPathName,
      rowId: new Date().getTime() + 'rowId' + val.id,
      pIndex,
      conditionActionType: 1,
    }))
  }

  // 弹出条件数据表格选择行
  onSelectedRows = selectedRows => {
    this.setState({ selectedRows })
  }

  // 弹出条件数据表格tab切换
  handleTabOnChange = (activeKey) => {
    this.setState({ activeKey })
  }

  conditionExtraChange= (record,value) => {
    record.conditionExtra = value
    let { records } = this.state
    if (records && Array.isArray(records) && records.length) {
      records.forEach(item => {
        if (item.rowId == record.rowId) {
          item = record
        }
      })
    }
  }
  // 弹出条件数据表格确认按钮
  onOk = () => {
    const { selectedRows, records, index } = this.state
    if(!selectedRows.length) {
      wizNotice.warn('请选择一行数据')
      return
    }
    const _formatSelectedRows = this.formatSelectedRows(selectedRows, index)

    if(index !== undefined) {
      const children = records[index].children || []
      // records[index].children = uniqBy([...children, ..._formatSelectedRows], 'rowId')
      records[index].children = [...children, ..._formatSelectedRows]

      this.setState({ visible: false, records: this.formatRecords(records) })
    } else {
      // const _filter = uniqBy([ ..._formatSelectedRows, ...records ], 'rowId')

      const _filter = [ ...records, ..._formatSelectedRows ]
      this.setState({ visible: false, records: this.formatRecords(_filter) })
    }
  }

  // 弹出条件数据表格取消按钮
  onCancel = () => {
    this.setState({ visible: false, activeKey: '0' })
  }

  _render() {
    const { visible, records, activeKey } = this.state
    const { beforeConditionLoading } = this.props
    const dataItems = getPageData({ records })
console.log(dataItems,'dataItems')
    const dataTableProps = {
      key: visible,
      loading: beforeConditionLoading,
      style: { marginTop: 15, minHeight: 150 },
      columns: columns.call(this, activeKey ),
      dataItems,
      rowKey: 'rowId',
      isScroll: true,
      defaultExpandAllRows: true
    }

    const modalProps = {
      visible,
      width: 950,
      onOk: this.onOk,
      onCancel: this.onCancel,
      style: { top: 30 }
    }

    // const menu = (
    //   <WizMenu>
    //     { this.config.map(val => <WizMenu.Item key={val.key} onClick={() => this.handleAddConditionGroup(val.key)}>{val.title}</WizMenu.Item>) }
    //   </WizMenu>
    // );

    return (
      <React.Fragment>
        <div style={{ padding: 10, minHeight: 300 }}>
          <WizRow type="flex" align="middle">
            <WizCol span={24}>
              <WizButton type="primary" style={{ marginRight: 15 }} onClick={() => this.handleAddCondition()} ghost>添加条件</WizButton>
              <WizButton onClick={ this.handleAddConditionGroup }>添加分组</WizButton>
            </WizCol>
          </WizRow>

          <WizDataTable {...dataTableProps} />

          <div style={{ paddingTop: 20, textAlign: 'center'}}>
              <WizButton type="primary" style={{ marginRight: 15 }} icon="check" onClick={ this.handleSubmit }>提交</WizButton>
              <WizButton icon="reload" onClick={ this.handleReset }>重置</WizButton>
          </div>
        </div>

        { visible? <WizModal { ...modalProps }>
          <WizTabs animated={false} onChange={this.handleTabOnChange}>
            { this.config.map((val, index) =>
              <WizTabs.TabPane tab={val.title} key={val.key}>
                <WizTableForm key={val.key} showModal={false} { ...val } onSelectedRows={ this.onSelectedRows } />
              </WizTabs.TabPane>
            )}
          </WizTabs>
        </WizModal> : null }

      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { beforeCondition } = state;
  const list = modelUtils.getModelEntity(beforeCondition,'beforeCondition@list');
  const save = modelUtils.getModelEntity(beforeCondition,'beforeCondition@save');
  // const del = modelUtils.getModelEntity(beforeCondition,'beforeCondition@del');

  const load = modelUtils.getLoadingState(state, "beforeCondition");

  return {
    list,
    save,
    // del,
    ...load,
  };
};

export default connect(mapStateToProps)(WizPreconditions);
